import authHeader from "../helpers/jwt-token-access/auth-token-header";
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
api.defaults.headers = authHeader();

export default api;
